/** First letter upper, rest lower — per word (handles "john paul", "DIVYANSHU"). */
export function capitalizeNamePart(value) {
  const v = String(value || '').trim();
  if (!v) return '';
  return v
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

export function formatPersonDisplayName(firstName, lastName) {
  const first = capitalizeNamePart(firstName);
  const last = capitalizeNamePart(lastName);
  return [first, last].filter(Boolean).join(' ').trim() || '—';
}
